import * as React from 'react'
import MUIMenu from '@mui/material/Menu'

const Menu = (props) => <MUIMenu {...props} />

export default Menu
